import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(num: number): string {
  // if (num >= 0 && num < 10) {
  //   return `0${num}`;
  // }
  return new Intl.NumberFormat().format(num);
}
